import { DataGrid } from '@mui/x-data-grid';
import { Button, CircularProgress, Typography } from '@mui/material';
import { useMemo } from 'react';
import { DataGridStyle } from '../../shared/sharedStyles';

export const UsersTable = ({ lngsltd, data, filteredData, storeLocations, handleEdit, handleDelete, handlesend, deletingUser }) => {

    const columns = useMemo(() => {
        return [
            { field: 'id', headerName: '#', width: 50, align: 'center', headerAlign: 'center' },
            {
                field: 'userEmail', headerName: lngsltd["User Email"], width: 250, align: 'center', headerAlign: 'center',
                renderCell: (params) => (
                    <div style={{
                        width: '100%',               //  required for proper centering
                        whiteSpace: 'normal',        //  enable wrapping
                        wordBreak: 'break-word',     //  prevent overflow
                        textAlign: 'center'
                    }}>
                        {params.value}
                    </div>
                )
            },
            {
                field: 'firstName', headerName: lngsltd["FirstName"], width: 110, align: 'center', headerAlign: 'center',
                renderCell: (params) => (
                    <div style={{
                        width: '100%',
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        textAlign: 'center'
                    }}>
                        {params.value}
                    </div>
                )
            },
            {
                field: 'lastName', headerName: lngsltd["LastName"], width: 110, align: 'center', headerAlign: 'center',
                renderCell: (params) => (
                    <div style={{
                        width: '100%',
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        textAlign: 'center'
                    }}>
                        {params.value}
                    </div>
                )
            },
            {
                field: 'role', headerName: lngsltd["User Role"], width: 110, align: 'center', headerAlign: 'center',
                renderCell: (params) => (
                    <div style={{
                        width: '100%',
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        textAlign: 'center'
                    }}>
                        {params.value}
                    </div>
                )
            },
            {
                field: 'storeLocation', headerName: lngsltd["Store Location"], width: 120, align: 'center', headerAlign: 'center',
                renderCell: (params) => (
                    <div style={{
                        width: '100%',
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        textAlign: 'center'
                    }}>
                        {params.value}
                    </div>
                )
            },
            {
                field: 'actions',
                headerName: lngsltd["Actions"],
                flex: 1,
                align: 'center',
                headerAlign: 'center',
                renderCell: (params) => (
                    <>
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={() => handleEdit(params.row.userEmail)}
                            sx={{ marginRight: 1 }}
                        >
                            {lngsltd["Edit"]}
                        </Button>
                        <Button
                            variant="outlined"
                            color="error"
                            size="small"
                            disabled={deletingUser === params.row.userEmail}
                            onClick={() => handleDelete(params.row.userEmail)}
                            sx={{
                                marginRight: 1,
                                minWidth: 90
                            }}
                        >
                            {deletingUser === params.row.userEmail ? (
                                <CircularProgress size={18} color="inherit" />
                            ) : (
                                lngsltd["Delete"]
                            )}
                        </Button>
                        <Button
                            variant="outlined"
                            color="secondary"
                            size="small"
                            onClick={() => handlesend(params.row.userEmail)}
                        >
                            {lngsltd["Send"]}
                        </Button>
                    </>
                )
            }
        ]
    }, [lngsltd, handleEdit, handleDelete, handlesend]);

    const rows = useMemo(() => {
        return filteredData.map((d, i) => ({
            ...d,
            id: i + 1,
            userEmail: d.userEmail,
            firstName: d.firstName,
            lastName: d.lastName,
            role: d.role,
            storeLocation: storeLocations[d.storeId],
            userID: d.userID
        }))
    }, [filteredData, storeLocations]);


    if (data.length === 0) {
        return (
            <Typography variant="h6" align="center" sx={{ paddingTop: '25px' }}>
                <CircularProgress />
            </Typography>
        );
    }
    return (
        <DataGrid
            rows={rows}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5, 10, 25]}
            disableSelectionOnClick
            disableColumnResize
            getRowHeight={() => 'auto'}   //  allows row height to grow when wrapping

            sx={{
                ...DataGridStyle,

                //  Force vertical + horizontal centering for ALL columns
                '& .MuiDataGrid-cell': {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }
            }}
        />

    );


}